import React from "react";
import UseTitle from "../../Hooks/UseTitle";
import About from "../About/About";
import Banner from "../Banner/Banner";
import ResortSurprize from "../ResortSurprize/ResortSurprize";
import Rooms from "../Rooms/Rooms";
import ServiceProvide from "../ServiceProvide/ServiceProvide";

const Home = () => {
  UseTitle("Home");
  return (
    <div className="-z-1">
      <Banner></Banner>
      <About></About>
      <ResortSurprize></ResortSurprize>
      <Rooms></Rooms>
      <ServiceProvide></ServiceProvide>
      {/* */}
      {/* <About></About> */}
    </div>
  );
};

export default Home;
